"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.atlanticPalette = void 0;
var themeCreator_1 = __importDefault(require("./themeCreator"));
exports.atlanticPalette = {
    component: {
        answerSelectedColor: 'rgb(18,189,156)',
        answerUnselectedColor: 'rgb(225, 225, 225)',
        continueButtonColor: 'rgb(55,84,160)',
        continueButtonHoverColor: 'rgb(92,120,199)',
        backButtonColor: 'rgb(237,237,237)',
        backButtonHoverColor: 'rgb(223,223,223)',
        progressBarFilledColor: 'rgb(18,189,156)',
        progressBarUnfilledColor: 'rgb(247,247, 247)',
        scrollIndicatorColor: 'rgb(55,84,160)',
    },
    background: {
        answerBackgroundColor: 'rgb(251, 251, 251)',
        secondaryBackgroundColor: 'rgb(234,247,254)',
        widgetBackgroundColor: 'rgb(255,255,255)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(0, 0, 0)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var atlanticTheme = (0, themeCreator_1.default)(exports.atlanticPalette);
exports.default = atlanticTheme;
//# sourceMappingURL=atlanticTheme.js.map